<template>
  <div class="blocks-view">
    <h1 class="text-h4 mb-4">{{ t('blocks.title') }}</h1>
    
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="4">
            <v-select
              v-model="filtroStatus"
              :items="opcoesStatus"
              label="Filtrar por status"
              density="comfortable"
              variant="outlined"
            ></v-select>
          </v-col>
          
          <v-col cols="12" sm="4">
            <v-select
              v-model="filtroValidador"
              :items="validadores"
              item-title="name"
              item-value="address"
              label="Filtrar por validador"
              density="comfortable"
              variant="outlined"
              clearable
            ></v-select>
          </v-col>
          
          <v-col cols="12" sm="4">
            <v-text-field
              v-model="filtroBloco"
              label="Número do bloco"
              type="number"
              density="comfortable"
              variant="outlined"
              clearable
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    
    <div class="mt-4">
      <BlocosList :blocos="blocosFiltrados" :loading="carregando" />
    </div>
    
    <v-pagination
      v-model="paginaAtual"
      :length="totalPaginas"
      :total-visible="7"
      class="mt-4"
    ></v-pagination>
  </div>
</template>

<script>
import { useBlockchainStore } from '@/stores/blockchain'
import BlocosList from '@/components/blocks/BlocosList.vue'

export default {
  name: 'BlocksView',
  components: {
    BlocosList
  },
  data() {
    return {
      carregando: true,
      blocos: [],
      paginaAtual: 1,
      itensPorPagina: 10,
      totalBlocos: 0,
      filtroStatus: 'todos',
      filtroValidador: null,
      filtroBloco: '',
      opcoesStatus: [
        { title: 'Todos', value: 'todos' },
        { title: 'Finalizados', value: 'finalized' },
        { title: 'Em Confirmação', value: 'confirming' }
      ],
      validadores: []
    }
  },
  computed: {
    blockchainStore() {
      return useBlockchainStore()
    },
    
    totalPaginas() {
      return Math.ceil(this.totalBlocos / this.itensPorPagina)
    },
    
    blocosFiltrados() {
      let blocosFiltrados = [...this.blocos]
      
      // Aplicar filtros
      if (this.filtroStatus !== 'todos') {
        blocosFiltrados = blocosFiltrados.filter(bloco => bloco.status === this.filtroStatus)
      }
      
      if (this.filtroValidador) {
        blocosFiltrados = blocosFiltrados.filter(bloco => bloco.validator === this.filtroValidador)
      }
      
      if (this.filtroBloco !== '') {
        const num = parseInt(this.filtroBloco)
        blocosFiltrados = blocosFiltrados.filter(bloco => bloco.number === num)
      }
      
      return blocosFiltrados
    }
  },
  methods: {
    async carregarBlocos() {
      this.carregando = true
      
      try {
        // Em produção, isso seria uma chamada para a API
        await this.blockchainStore.fetchLatestBlocks(20)
        this.blocos = this.blockchainStore.latestBlocks
        this.totalBlocos = this.blockchainStore.totalBlocks // Em produção, viria da API
        
        console.log('Blocos carregados:', this.blocos.length)
      } catch (error) {
        console.error('Erro ao carregar blocos:', error)
      } finally {
        this.carregando = false
      }
    },
    
    async carregarValidadores() {
      try {
        await this.blockchainStore.fetchValidators()
        this.validadores = this.blockchainStore.validators
      } catch (error) {
        console.error('Erro ao carregar validadores:', error)
      }
    }
  },
  async mounted() {
    await Promise.all([
      this.carregarBlocos(),
      this.carregarValidadores()
    ])
  },
  watch: {
    paginaAtual() {
      this.carregarBlocos()
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped>
.blocks-view {
  padding-bottom: 32px;
}
</style>
